import React from 'react';
import AtlasV2MetricSpineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricSpineChart';
import useMarketShareHooks from 'src/components/AtlasV2Components/Hooks/useMarketShareRequestHook';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasV2TotalTrafficShareByKeyword = () => {
  const { requestBuilder, marketShareBuilder } = useMarketShareHooks();

  return (
    <AtlasV2MetricSpineChart
      indexName="traffic"
      fieldName="totalClicks"
      title="Share of Total Traffic"
      metricTypeDisplay={METRICTYPE.PERCENT}
      requestBuilder={requestBuilder}
      marketShareBuilder={marketShareBuilder}
    />
  );
};
export default AtlasV2TotalTrafficShareByKeyword;
